export default "__VITE_ASSET__BRB5_Pla__"